module.exports = __webpack_public_path__ + "img/mask-right.ddb84193.png";